import React from 'react';
import { connect } from 'react-redux';

import { sidebarClose, sidebarLock } from 'actions/sidebarActions';
import SidebarModalButton from 'components/sidebars/SidebarModalButton';
import CustomIcon from 'components/common/CustomIcon';

const stateToProps = ({ sidebar: { locked } }) => ({
    locked
});

const dispatchToProps = {
    sidebarLock,
    sidebarClose
};

const SidebarHeader = ({ children, title, locked, sidebarLock, sidebarClose, disableLock, modal }) => (
    <div className="right-sidebar-header">
        <span className="title" title={title}>
            {children}
        </span>
        <SidebarModalButton modal={modal} />
        { !disableLock && <CustomIcon type={locked ? 'lock' : 'open'} onClick={sidebarLock} />}
        <CustomIcon type="close" className="trigger" onClick={sidebarClose} />
    </div>
);

export default connect(stateToProps, dispatchToProps)(SidebarHeader);
